/**
 * Pure SVG sparkline per the dataviz mark specs: 2px line with round
 * joins, an area wash at 10 percent opacity, and an end dot of at least
 * 8px carrying a 2px surface ring. No axes, no grid; the tile's value and
 * label carry the numbers, the sparkline carries the shape.
 */
export function Sparkline({
  points,
  color,
  width = 220,
  height = 44,
}: {
  points: number[];
  color: string;
  width?: number;
  height?: number;
}) {
  if (points.length < 2) return null;
  const max = Math.max(...points, 1);
  const pad = 6;
  const w = width - pad * 2;
  const h = height - pad * 2;
  const x = (i: number) => pad + (i / (points.length - 1)) * w;
  const y = (v: number) => pad + h - (v / max) * h;

  const path = points.map((v, i) => `${i === 0 ? 'M' : 'L'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  const area = `${path} L${x(points.length - 1).toFixed(1)},${(pad + h).toFixed(1)} L${pad},${(pad + h).toFixed(1)} Z`;
  const lastIndex = points.length - 1;
  const lastValue = points[lastIndex] ?? 0;

  return (
    <svg viewBox={`0 0 ${width} ${height}`} height={height} role="img" aria-label="trend">
      <path d={area} fill={color} opacity={0.1} />
      <path d={path} fill="none" stroke={color} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(lastIndex)} cy={y(lastValue)} r={4} fill={color} stroke="var(--surface)" strokeWidth={2} />
    </svg>
  );
}
